import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';
import FaqHero from './components/FaqHero';
import FaqCategories from './components/FaqCategories';
import FaqAccordion from './components/FaqAccordion';
import FaqContact from './components/FaqContact';
import FaqSeoBlock from './components/FaqSeoBlock';
import { updatePageSEO } from '../../utils/seoConfig';

const FaqPage = () => {
  useEffect(() => {
    updatePageSEO('faq');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <FaqHero />
        <FaqCategories />
        <FaqAccordion />
        <FaqContact />
        <FaqSeoBlock />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default FaqPage;
